import { Grid, Typography, InputAdornment, Box, TextField, Stack, CircularProgress, Button, useTheme, Paper, Chip, RadioGroup, FormControlLabel, Radio, } from "@mui/material";
import React, { useLayoutEffect, useState } from "react";
import { CalendarIcon, ClockIcon, DeleteIcon, LocationIcon, PlusIcon } from "../../components/IconComponent";
import { emptyStringIfNull, epochToDatetimeStrWithTz } from "../../utils/util";
import LinkComponent from "../../components/Link";
import { useTranslation } from "react-i18next";
import DatePicker from '../../components/DatePicker';
import TimePicker from '../../components/TimePicker';

export default function ScheduleDateNotesView(props) {
    const { activity, isSelfScheduleingUser, files, setAllNote, allNote, pagingNote, onLoadMoreNoteActivity, loadMoreNote, dataNoteActivity } = props;
    const { t } = useTranslation()
    const { palette } = useTheme();
    const [note, setNote] = useState(null);
    const [scheduledDate, setScheduledDate] = useState(null);
    const [scheduledTime, setScheduledTime] = useState(null);
    const [scheduledTimeFrom, setScheduledTimeFrom] = useState(null);
    const [scheduledTimeTo, setScheduledTimeTo] = useState(null);
    const [isChangeScheduleDate, setIsChangeScheduleDate] = useState(false);

    useLayoutEffect(() => {
        if (activity.date)
            setScheduledDate(activity.date);

        if (activity.from_time && activity.to_time) {
            setScheduledTime('SPECIFIC');
            setScheduledTimeFrom(activity.from_time);
            setScheduledTimeTo(activity.to_time);
        } else
            setScheduledTime('ALL');
    }, []);

    const onChangeNote = (event) => {
        setNote(event.target.value);
        if (props.setNote) props.setNote(event.target.value)
    }
    const handleAddNote = () => {
        setAllNote([...allNote, note]);
        setNote("");
        if (props.setNote) props.setNote("")
    }
    const handleDeleteAllNote = (index) => {
        setAllNote(allNote.filter((item, i) => i !== index));
    };

    const handleDateChange = (date) => {
        setScheduledDate(date);
        setIsChangeScheduleDate(true);
    };

    const handleChangeSchedule = (event) => {
        setScheduledTime(event.target.value);
    };

    const handleChangeScheduledTimeFr = (date) => {
        setScheduledTimeFrom(date);
    };

    const handleChangeScheduledTimeTo = (date) => {
        setScheduledTimeTo(date);
    };

    return (
        <>
            <Grid xs={12} item component={Paper} paddingX={2} paddingY={1}>
                <Typography variant='subtitle1'>{"Activity"} {activity.custom_fields.find(field => field.key === 'activity_number')?.value}</Typography>
                {activity && <Grid xs={12} item marginTop={1}>
                    {activity.description && <Stack spacing={1} marginBottom={1} direction={'row'} >
                        <Typography variant='subtitle2'>{t('description') + ':'}</Typography>
                        <Typography variant='subtitle2'>{activity.description}</Typography>
                    </Stack>}
                    {activity.address && <Stack flex={1} direction={'row'} spacing={1} marginBottom={1}>
                        <LocationIcon />
                        <Typography variant='subtitle2'>{activity.address.address_line_1 +
                            emptyStringIfNull(activity.address.address_line_2) +
                            emptyStringIfNull(activity.address.state_province_county) +
                            emptyStringIfNull(activity.address.town_city) +
                            emptyStringIfNull(activity.address.postal_code)}
                        </Typography>
                    </Stack>}
                    <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                        <CalendarIcon />
                        <Typography variant='subtitle2'>{t('created_date') + ': '}</Typography>
                        <Typography variant='subtitle2'>{epochToDatetimeStrWithTz(activity.created_date, true)}</Typography>
                    </Stack>
                    {isSelfScheduleingUser && isSelfScheduleingUser === "true" &&
                        <Stack>
                            <Stack direction={'row'} spacing={1} marginBottom={0.5} alignItems="center">
                                <Typography marginBottom={0.5} variant='subtitle2'>{t('scheduled_date') + ':'}</Typography>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue={scheduledTime}
                                    name="radio-buttons-group"
                                    value={scheduledTime}
                                    onChange={handleChangeSchedule}
                                >
                                    <Stack direction={'row'} sx={{
                                        ".css-1xhn9g2-MuiButtonBase-root-MuiRadio-root": {
                                            padding: "8px 3px 8px 8px"
                                        },
                                        ".css-193gtzj-MuiTypography-root": {
                                            fontSize: "14px",
                                            fontFamily: "Roboto-Regular"
                                        }
                                    }}>
                                        <FormControlLabel value="ALL" control={<Radio />} label="All day" />
                                        <FormControlLabel value="SPECIFIC" control={<Radio />} label="On specific hours" />
                                    </Stack>
                                </RadioGroup>
                            </Stack>
                            <Stack direction={'row'} spacing={1} marginBottom={0.5} alignItems="center">
                                <DatePicker onChange={handleDateChange} scheduledDate={activity.date} />
                                <Typography variant='subtitle2'>{' at '}</Typography>
                                {scheduledTime != 'ALL' &&
                                    <Stack direction={'row'} alignItems="center" spacing={0.5}>
                                        <TimePicker onChange={handleChangeScheduledTimeFr} scheduledTime={scheduledTimeFrom} scheduledDate={activity.date} />
                                        <Typography variant='subtitle2'>{' - '}</Typography>
                                        <TimePicker onChange={handleChangeScheduledTimeTo} scheduledTime={scheduledTimeTo} scheduledDate={activity.date} />
                                    </Stack>
                                }
                                {scheduledTime === 'ALL' && <Typography variant='subtitle2'>{'All day'}</Typography>}
                            </Stack>
                        </Stack>
                    }
                    {!isSelfScheduleingUser || isSelfScheduleingUser === "false" &&
                        <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                            <ClockIcon />
                            <Typography variant='subtitle2'>{t('scheduled_date') + ': '}</Typography>
                            <Typography variant='subtitle2'>{epochToDatetimeStrWithTz(activity.date, false, true) + (activity.from_time ? ` at ${activity.from_time}` : ' All day') + (activity.to_time ? ` - ${activity.to_time}` : '')}</Typography>
                        </Stack>
                    }
                </Grid>}
            </Grid>
            <Grid xs={12} my={1} item component={Paper} paddingX={2} paddingY={2}>
                <Grid xs={12} my={1} item >
                    <Typography marginBottom={0.5} variant='subtitle2'>{t('notes') + ': '}</Typography>
                    <TextField
                        type={'text'}
                        multiline={true}
                        rows={3.2}
                        onChange={onChangeNote}
                        value={note}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                paddingX: 2,
                                paddingY: 1
                            },
                            '.MuiOutlinedInput-input': {
                                padding: 0
                            },
                            ".css-wobjcf-MuiInputBase-root-MuiOutlinedInput-root": {
                                alignItems: "start"
                            }
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Box
                                        mt={"10px"}
                                        onClick={handleAddNote}
                                        width={30}
                                        sx={{ cursor: "pointer" }}
                                        height={30}
                                        display={"flex"}
                                        justifyContent={"center"}
                                        alignItems={"start"}
                                    >
                                        <PlusIcon />
                                    </Box>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {allNote.length > 0 &&
                        <Box sx={{ maxHeight: "200px", overflowY: "scroll", border: `1px solid #dddddd`, padding: "10px", marginTop: "10px", borderRadius: "5px" }}>
                            {allNote.map((item, index) => {
                                return (
                                    <Box
                                        display={"flex"}
                                        justifyContent={"space-between"}
                                        gap={"10px"}
                                        borderTop={index == 0 ? "none" : "1px solid #dddddd"}
                                        pt={"5px"}
                                    >
                                        <Typography sx={{ overflowWrap: "break-word" }} width={"90%"} variant='subtitle2'>{item}</Typography>
                                        <Stack
                                            sx={{ cursor: "pointer" }}
                                            direction={"row"}
                                            gap={"10px"}
                                            alignItems={"center"}
                                        >
                                            <Box onClick={() => handleDeleteAllNote(index)}>
                                                <DeleteIcon size={15} />
                                            </Box>
                                        </Stack>
                                    </Box>

                                );
                            })}
                        </Box>
                    }
                </Grid>
                {dataNoteActivity && dataNoteActivity.length > 0 && <Grid xs={12} my={1} item >
                    <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography marginBottom={0.5} variant='subtitle2'>Noted List</Typography>
                    </Stack>
                    <Stack direction={"column"} sx={{ maxHeight: "200px", overflowY: "scroll" }} gap={"10px"}>
                        {dataNoteActivity.map((item) => {
                            return <Stack key={item.id}  >
                                <Stack direction={"row"} border={"1px solid #dddddd"} justifyContent={"space-between"} borderRadius={"5px"} p={"8px 10px"}>
                                    <Box width={"70%"}>
                                        <Typography fontWeight={"bold"} variant='subtitle2' >{item.created_by.name}</Typography>
                                        <Typography sx={{ overflowWrap: "break-word" }} variant='subtitle2'>{item.note}</Typography>
                                    </Box>
                                    <Box width={"25%"}>
                                        <Typography fontSize={"13px"} variant='subtitle2'>{epochToDatetimeStrWithTz(item.created_on, true)}</Typography>
                                    </Box>
                                </Stack>
                            </Stack>
                        })}
                    </Stack>
                    {loadMoreNote && <center><CircularProgress size={'20'} /></center>}
                    {/* {pagingNote && pagingNote.has_more && <center>
                        <LinkComponent onClick={() => onLoadMoreNoteActivity()}>{t('load_more')}</LinkComponent>
                    </center>} */}
                </Grid>}
                <Grid my={1} paddingY={2}>
                    <Stack sx={{ cursor: 'pointer' }} direction={'row'} spacing={1}
                        border={'1px solid ' + palette.border.main}
                        px={2} py={1}
                        borderRadius={1}
                        onClick={() => props.setShowUploadFile(true)}>
                        <Stack flex={1}>
                            <Typography variant='subtitle1'>{t('attach_files')}</Typography>
                        </Stack>
                        <Stack direction={'row'} flex={0.2} justifyContent='flex-end'>
                            <PlusIcon />
                        </Stack>
                    </Stack>
                    {activity.files && (
                        <Stack flex={1} spacing={0.5} marginTop={1}>
                            <Typography variant='subtitle1'>{"Files:"}</Typography>
                            {activity.files.map(file => (
                                <LinkComponent key={file.file.name} onClick={() => props.onShowFile(file.file)} color="blue">{file.file.name}</LinkComponent>
                            ))}
                        </Stack>
                    )}
                    <Grid item container xs={12} marginTop={2}>
                        {files && files.length > 0 && files.map((f, i) => {
                            return (
                                <Box key={i} position={'relative'} width={48} height={48} marginRight={1}>
                                    <img alt={f.name} src={f.uri} width={48} height={48} />
                                    <Box position={'absolute'} right={0} top={0} onClick={() => props.onDeleteFile(f)}>
                                        <Box display={'flex'} my={0.5} mx={0.5} justifyContent={'center'} alignItems='center' width={25} height={25} borderRadius={1} backgroundColor={palette.background.main}>
                                            <DeleteIcon size={'18px'} />
                                        </Box>
                                    </Box>
                                </Box>
                            )
                        })}
                    </Grid>
                    <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                        <Button sx={{ marginRight: 2 }} variant='contained'
                            onClick={() => props.onSave({
                                note: note, 
                                removedSerial: undefined, 
                                saveButtonPressed: true, 
                                scheduledDate: scheduledDate, 
                                scheduledTime: scheduledTime, 
                                scheduledTimeFrom: scheduledTimeFrom, 
                                scheduledTimeTo: scheduledTimeTo,
                                changeScheduleDate: isChangeScheduleDate,
                            })}
                        >
                            {t('save')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}